import * as Toast from 'vue-toastification';
const { useToast } = Toast;

export function useNotify() {
    const isMounted = useMounted();
    const toast = computed(() => (isMounted.value ? useToast() : null));
    function ssrGuard<TArgs extends unknown[], TResult>(
        func: (...args: TArgs) => TResult
    ) {
        return (...args: TArgs): TResult => {
            if (toast.value) {
                return func(...args);
            }
            throw new Error('Toast is not defined in ssr context.');
        };
    }
    function $error(text = 'خطایی رخ داده است.', timeout?: number) {
        toast.value?.error(text, { timeout });
    }

    function $success(text = 'عملیات با موفقیت انجام شد.', timeout?: number) {
        toast.value?.success(text, { timeout });
    }

    function $info(text: string, timeout?: number) {
        toast.value?.info(text, { timeout });
    }

    function $warning(text: string, timeout?: number) {
        toast.value?.warning(text, { timeout });
    }

    function $clear() {
        toast.value?.clear();
    }

    return {
        $clear: ssrGuard($clear),
        $error: ssrGuard($error),
        $info: ssrGuard($info),
        $warning: ssrGuard($warning),
        $success: ssrGuard($success),
    };
}
